export default {
  buttons: {
    skip: 'Ignorer',
    back: 'Retour',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    payment: {
      pending: 'Votre paiement est en cours de traitement...',
      success: '👍 Votre paiement a été traité avec succès. Merci !',
      error:
        '⁉️Un problème est survenu avec votre paiement ou le traitement prend plus longtemps que prévu. Veuillez rafraîchir la page pendant 1 minute, sinon contactez le support technique.',
    },
  },
};
